var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-caroucel"},[_c('client-only',[_c('carousel',{attrs:{"items":1,"URLhashListener":true,"loop":true,"nav":false,"autoplayTimeout":7000,"autoplay":true,"autoplayHoverPause":true}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }